import React from 'react';
import { FileText, Calculator, Receipt, FolderOpen } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

interface ModuleSidebarProps {
  currentModule: 'quotes' | 'scrollitelling' | 'rechnungen' | 'templates';
  onModuleChange: (module: 'quotes' | 'scrollitelling' | 'rechnungen' | 'templates') => void;
}

const ModuleSidebar: React.FC<ModuleSidebarProps> = ({ currentModule, onModuleChange }) => {
  const { userProfile } = useAuth();
  
  // Only show for admins
  if (userProfile?.role !== 'admin') return null;

  const modules = [
    {
      id: 'quotes' as const,
      name: 'Angebote Webentwicklung',
      icon: Calculator,
      colorActive: 'bg-blue-600',
      colorHover: 'hover:bg-gray-700'
    },
    {
      id: 'scrollitelling' as const,
      name: 'Fragebögen',
      icon: FileText,
      colorActive: 'bg-purple-600',
      colorHover: 'hover:bg-gray-700'
    },
    {
      id: 'templates' as const,
      name: 'Vorlagen',
      icon: FolderOpen,
      colorActive: 'bg-indigo-600',
      colorHover: 'hover:bg-gray-700'
    },
    {
      id: 'rechnungen' as const,
      name: 'Rechnungen',
      icon: Receipt,
      colorActive: 'bg-green-600',
      colorHover: 'hover:bg-gray-700'
    }
  ];

  return (
    <div className="fixed left-0 top-14 h-[calc(100vh-3.5rem)] w-20 bg-gray-900 border-r border-gray-700 flex flex-col items-center py-6 gap-6 z-40">
      {modules.map((module) => {
        const Icon = module.icon;
        const isActive = currentModule === module.id;
        
        return (
          <button
            key={module.id}
            onClick={() => onModuleChange(module.id)}
            className={`
              w-14 h-14 rounded-xl flex items-center justify-center
              transition-all duration-200 relative group
              ${isActive 
                ? `${module.colorActive} text-white shadow-lg scale-110` 
                : `bg-gray-800 text-gray-400 ${module.colorHover} hover:text-white`
              }
            `}
            title={module.name}
            aria-label={module.name}
          >
            <Icon className="w-6 h-6" />
            
            {/* Tooltip */}
            <div className="absolute left-20 bg-gray-800 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50 shadow-lg">
              {module.name}
              <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1 w-2 h-2 bg-gray-800 rotate-45"></div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ModuleSidebar;

